<template>
  <div class="row print-machine-products">
    <div class="col-6">
            <div class="row">
                <div class="col mx-2">
                    <form class="form-inline py-2 justify-content-start" >
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-back btn-lg" @click="$router.push(`/settings/print-machines/card/${printMachineId}`)">
                            <i class="fa fa-angle-left px-1"></i>
                        </button>
                        <h2 class="ml-2">{{printMachineName}} / Настройка продуктов</h2>
                    </div>
                    </form>
                </div>
            </div>
             <div class="row mt-4">
                <div class="col mx-2">
                    <div class="input-group with-clear-icon">
                        <input type="text" class="form-control" v-model="searchText">
                        <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
                        <div class="input-group-append">
                            <span class="input-group-text"><i class="fa fa-search"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col mx-2">
                     <router-link class="btn btn-outline-primary" :to="`/settings/print-machine-products/${printMachineId}/product-card/0`" tag="button" :disabled="$route.path===`/settings/print-machine-products/${printMachineId}/product-card/0`">
                          <i class="ico ico-plus mr-2"></i>Добавить продукт
                    </router-link>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col mx-2">
                    <ul class="list-unstyled product-items">
                        <router-link class="product-item mt-2 px-4" :to="`/settings/print-machine-products/${printMachineId}/product-card/${product.id}`" tag="li" v-for="product in products"
                            :key="product.id" :class="{'product-item-disabled' : !product.enabled}">
                            <span class="product-item-name" :title="product.name">{{product.name}}</span>
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-6">
            <router-view></router-view>
        </div>
  </div>
</template>

<script>
import api from '../../../api'
import { sortBy } from 'lodash'

const mapProduct = product => {
  return {
    id: product.id,
    name: product.name,
    enabled: product.enabled
  }
}

export default {
  name: 'PrintMachineProducts',
  props: {
    printMachineId: {
      default: null
    }
  },
  data: () => {
    return {
      searchText: '',
      printMachineProducts: [],
      printMachineName: ''
    }
  },
  methods: {
    loadPrintMachineProducts (pmId) {
      api.get
        .printMachineProducts(pmId)
        .then(resp => {
          this.printMachineProducts = resp.data.data.products
            .map(mapProduct)
            .sort(function (a, b) {
              if (a.name > b.name) {
                return 1
              }
              if (a.name < b.name) {
                return -1
              }
              return 0
            })
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    loadPrintMachineName (pmId) {
      api.get
        .printMachine(pmId)
        .then(resp => {
          this.printMachineName = resp.data.data.printMachine.name.toUpperCase()
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    clearSearchText () {
      this.searchText = ''
    }
  },
  computed: {
    pmId () {
      return +this.printMachineId
    },
    products () {
      let filteredProducts
      if (this.searchText) {
        filteredProducts = this.printMachineProducts.filter(x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0)
      } else {
        filteredProducts = this.printMachineProducts
      }

      return sortBy(filteredProducts, pr => pr.name.toLowerCase())
    }
  },
  created: function () {
    this.loadPrintMachineProducts(this.pmId)
    this.loadPrintMachineName(this.pmId)
    this.$eventBus.$on('updatePrintMachineProducts', () => {
      this.loadPrintMachineProducts(this.pmId)
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки продуктов')
    })
  }
}
</script>

<style>

</style>
